import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2TelInputModule } from 'ng2-tel-input';

import { ComponentsRoutingModule } from './components-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgOtpInputModule } from  'ng-otp-input';
import {NgxPaginationModule} from 'ngx-pagination';
import { ComponentsComponent } from './components.component';
import { AuthComponent } from './auth/auth.component';
import { LoginComponent } from './auth/login/login.component';
import { SharedModule } from './shared/shared.module';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { LayoutComponent } from './layout/layout.component';
import { AlertComponent } from './layout/alert/alert.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { ManagerComponent } from './layout/manager/manager.component';
import { EventManagerComponent } from './layout/event-manager/event-manager.component';
import { CampusGreetingComponent } from './layout/campus-greeting/campus-greeting.component'
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BankAccountSettingComponent } from './layout/bank-account-setting/bank-account-setting.component';
import { DailyHeraldsComponent } from './layout/daily-heralds/daily-heralds.component';
import { MemberSearchComponent } from './layout/member-search/member-search.component';
import { ProfileManagement2Component } from './layout/profile-management2/profile-management2.component';
import { ProfileManagementComponent } from './layout/profile-management/profile-management.component';
import { SettingsComponent } from './layout/settings/settings.component';
import { OurNetworkComponent } from './layout/our-network/our-network.component';
import { SocialPostComponent } from './layout/social-post/social-post.component';
import { UserRegistrationComponent } from './auth/user-registration/user-registration.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbDropdownModule, NgbModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { BasicInfoComponent } from './auth/user-registration/basic-info/basic-info.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AddressComponent } from './auth/user-registration/address/address.component';
import { SocialLinksComponent } from './auth/user-registration/social-links/social-links.component';
import { AboutUsComponent } from './auth/user-registration/about-us/about-us.component';
import { CustomTextFieldsComponent } from './auth/user-registration/custom-text-fields/custom-text-fields.component';
import { EmailVerficationComponent } from './auth/email-verfication/email-verfication.component';
import { CreateAlertsComponent } from './layout/create-alerts/create-alerts.component';
import { CreateEventComponent } from './layout/event-manager/create-event/create-event.component';
import { DetailEventComponent } from './layout/event-manager/detail-event/detail-event.component';
import { EditEventsComponent } from './layout/event-manager/edit-events/edit-events.component';
import { CreateDailyHeraldsComponent } from './layout/daily-heralds/create-daily-heralds/create-daily-heralds.component';
import { CreatePostComponent } from './layout/social-post/create-post/create-post.component';
import { SocialCommentComponent } from './layout/social-post/social-comment/social-comment.component';
import { ClaimComponent } from './auth/claim/claim.component';
import { ClaimFellowshipComponent } from './auth/claim/claim-fellowship/claim-fellowship.component';
import { ClaimFilterComponent } from './auth/claim/claim-filter/claim-filter.component';
import { OthersProfileComponent } from './auth/claim/others-profile/others-profile.component';
import { FellowshipDirectoryComponent } from './layout/fellowship-directory/fellowship-directory.component';
import { MerchantDirectoryComponent } from './layout/merchant-directory/merchant-directory.component';
import { SupportComponent } from './layout/support/support.component';
import { CreateTicketComponent } from './layout/support/create-ticket/create-ticket.component';
import { ChatSupportComponent } from './layout/support/chat-support/chat-support.component';
import { FaqComponent } from './layout/faq/faq.component';
import { FellowshipDetailsComponent } from './layout/fellowship-directory/fellowship-details/fellowship-details.component';
import { UnblockUserComponent } from './layout/our-network/unblock-user/unblock-user.component';
import { OurNetworkothersComponent } from './layout/fellowship-directory/our-networkothers/our-networkothers.component';
import { StaffManegerComponent } from './layout/staff-maneger/staff-maneger.component';
import { NotificationComponent } from './layout/notification/notification.component';
import { BulltineComponent } from './layout/bulltine/bulltine.component';
import { CreateBulletineComponent } from './layout/bulltine/create-bulletine/create-bulletine.component';
import { VideoManagerComponent } from './layout/video-manager/video-manager.component';
import { CreateVideoComponent } from './layout/video-manager/create-video/create-video.component';
import { FilterComponent } from './layout/fellowship-directory/filter/filter.component';
import { DisableDirDirective } from './layout/campus-greeting/disable-dir.directive';
import { PhotoGalleryComponent } from './layout/photo-gallery/photo-gallery.component';
import { AddPhotoGalleryComponent } from './layout/photo-gallery/add-photo-gallery/add-photo-gallery.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditProfileComponent } from './layout/edit-profile/edit-profile/edit-profile.component';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from "ngx-ui-loader";
import { CrossChatComponent } from './layout/cross-chat/cross-chat.component';
import { PartnerComponent } from './layout/partner/partner.component';
import { AssociationManagerComponent } from './layout/association-manager/association-manager.component';
import { MentorManagerComponent } from './layout/mentor-manager/mentor-manager.component';
import { HousingHubComponent } from './layout/housing-hub/housing-hub.component';
import { CreateHousingComponent } from './layout/housing-hub/create-housing/create-housing.component';
import { CreateJobComponent } from './layout/jobs/create-job/create-job.component';
import { JobsComponent } from './layout/jobs/job.component';
import { PayoutAccountComponent } from './payout-account/payout-account.component';
import { DonationsComponent } from './layout/donations/donations.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "bgsColor": "red",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 5,
  "delay": 0,
  "fastFadeOut": true,
  "fgsColor": "red",
  "fgsPosition": "center-center",
  "fgsSize": 50,
  "fgsType": "ball-spin-clockwise",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 120,
  "logoUrl": "",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "red",
  "pbColor": "red",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "maxTime": -1,
  "minTime": 300
};

@NgModule({
  declarations: [

    ComponentsComponent,
    AuthComponent,
    LoginComponent,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    LayoutComponent,
    AlertComponent,
    SidebarComponent,
    ManagerComponent,
    EventManagerComponent,
    HousingHubComponent,
    JobsComponent,
    CampusGreetingComponent,
    BankAccountSettingComponent,
    DailyHeraldsComponent,
    MemberSearchComponent,
    ProfileManagement2Component,
    ProfileManagementComponent,
    SettingsComponent,
    OurNetworkComponent,
    SocialPostComponent,
    UserRegistrationComponent,
    BasicInfoComponent,
    AddressComponent,
    SocialLinksComponent,
    AboutUsComponent,
    CustomTextFieldsComponent,
    EmailVerficationComponent,
    CreateAlertsComponent,
    CreateEventComponent,
    CreateHousingComponent,
    CreateJobComponent,
    DetailEventComponent,
    EditEventsComponent,
    CreateDailyHeraldsComponent,
    CreatePostComponent,
    SocialCommentComponent,
    ClaimComponent,
    ClaimFellowshipComponent,
    ClaimFilterComponent,
    OthersProfileComponent,
    FellowshipDirectoryComponent,
    MerchantDirectoryComponent,
    SupportComponent,
    CreateTicketComponent,
    ChatSupportComponent,
    FaqComponent,
    FellowshipDetailsComponent,
    UnblockUserComponent,
    OurNetworkothersComponent,
    StaffManegerComponent,
    NotificationComponent,
    BulltineComponent,
    CreateBulletineComponent,
    VideoManagerComponent,
    CreateVideoComponent,
    FilterComponent,
    DisableDirDirective,
    PhotoGalleryComponent,
    AddPhotoGalleryComponent,
    EditProfileComponent,
    CrossChatComponent,
    PartnerComponent,
    AssociationManagerComponent,
    MentorManagerComponent,
    PayoutAccountComponent,
    DonationsComponent,

  ],
  imports: [
    CommonModule,
    ComponentsRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    GooglePlaceModule,
    TimepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    NgbModule,
    NgxIntlTelInputModule,
    NgOtpInputModule,
    NgxPaginationModule,
    Ng2TelInputModule,
    NgSelectModule,
    NgbDropdownModule,
    // NgxUiLoaderModule,
    NgbTimepickerModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
  ]
})
export class ComponentsModule { }
